/*
 * Common Messages
 *
 * This contains all common texts
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
    email: {
        id: 'app.common.email',
        defaultMessage: 'Email',
    },
    password: {
        id: 'app.common.password',
        defaultMessage: 'Password',
    },
    code: {
        id: 'app.common.code',
        defaultMessage: 'Two-Factor Authentication Code',
    },
    login: {
        id: 'app.common.login',
        defaultMessage: 'Login',
    },
    authenticationError: {
        id: 'app.common.authenticationError',
        defaultMessage: 'Please check provided email and password and your internet connection',
    },
    signup: {
        id: 'app.common.signup',
        defaultMessage: 'Create',
    },
    ForgotPassword: {
        id: 'app.common.forgotPassword',
        defaultMessage: 'Reset Password',
    },
    logout: {
        id: 'app.common.logout',
        defaultMessage: 'Logout',
    },
    save: {
        id: 'app.common.save',
        defaultMessage: 'Save',
    },
});
